import { UnitId, unitIdToLegacyUnitId } from "../../Unit/UnitId/UnitId";

import { IUnitController, IUnitRegistry } from "./IUnitRegistry";

export class UnitRegistry implements IUnitRegistry {
    private readonly unitMap = new Map<string, IUnitController>();

    public registerUnit(unitId: UnitId, unitController: IUnitController): void {
        this.unitMap.set(unitIdToLegacyUnitId(unitId), unitController);
    }

    public unregisterUnit(unitId: UnitId): void {
        this.unitMap.delete(unitIdToLegacyUnitId(unitId));
    }

    public getUnitController(unitId: UnitId): IUnitController | undefined {
        return this.unitMap.get(unitIdToLegacyUnitId(unitId));
    }
}
